import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSiteSettings } from '../context/SiteSettingsContext';
import MaintenancePage from './MaintenancePage';

export default function MaintenanceGate({ children }) {
  const location = useLocation();
  const { settings, loading } = useSiteSettings();

  const isAdminRoute = location.pathname.startsWith('/admin');
  if (isAdminRoute || loading || !settings.maintenance.enabled) {
    return children;
  }

  return <MaintenancePage />;
}
